import { useCallback, useEffect, useRef, useState } from "react";

import type { IEmbedSize } from "~/feature/embed/utils/getEmbedMinSize";
import { getFitScale } from "~/feature/embed/utils/getFitScale";

import { EMBED_PREVIEW_MAX_HEIGHT } from "./constants";

export const useFitScale = (content: IEmbedSize) => {
  const [available, setAvailable] = useState<number | null>(null);
  const observer = useRef<ResizeObserver | null>(null);

  const ref = useCallback((node: HTMLElement | null) => {
    observer.current?.disconnect();

    if (!node) return;

    setAvailable(node.clientWidth);

    if (typeof ResizeObserver === "undefined") return;

    observer.current = new ResizeObserver(([entry]) =>
      setAvailable(entry.contentRect.width)
    );
    observer.current.observe(node);
  }, []);

  useEffect(() => () => observer.current?.disconnect(), []);

  return {
    ref,
    scale: getFitScale(content, available, EMBED_PREVIEW_MAX_HEIGHT),
  };
};
